import {SwitchProps} from "@mui/material";
import {Control, Controller, FieldValues, Path, useFormContext} from "react-hook-form";
import CustomSwitch from "../components/CustomSwitch";

type FormCustomSwitchProps<IFormValues extends FieldValues = FieldValues, T extends any = any, DisableClearable extends (boolean | undefined) = undefined, FreeSolo extends (boolean | undefined) = undefined> =
    Omit<SwitchProps, "ref" | "value" | "renderInput">
    & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>,
    label: string,
    handleChange?: Function,
    readOnly?: boolean
    required?: boolean,
}

const FormCustomSwitch = <IFormValues extends FieldValues, T extends any = any, DisableClearable extends boolean | undefined = boolean, FreeSolo extends boolean | undefined = boolean>(
    {
        name,
        control,
        label,
        readOnly,
        handleChange,
        ...props
    }: FormCustomSwitchProps<any, T, DisableClearable, FreeSolo>) => {

    // Use Form Context
    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            render={({field, formState}) =>
                <CustomSwitch
                    {...props}
                    value={field.value || false}
                    label={label}
                    handleChange={(checked: boolean) => {
                        if (handleChange) {
                            handleChange(checked);
                        } else {
                            field.onChange(checked);
                        }
                    }}
                    readOnly={readOnly ?? formState.isSubmitting}
                />
            }
        />
    );
};

export default FormCustomSwitch;